import { alertClasses } from '@mui/material/Alert';
import palette from '../palette';
import typography from '../typography';

const MuiAlert = {
  defaultProps: {
    variant: 'filled',
  },
  styleOverrides: {
    root: {
      '&.MuiAlert-filled.MuiAlert-colorError': {
        backgroundColor: palette.error.light,
        color: palette.error.dark,
      },
      '&.MuiAlert-filled.MuiAlert-colorSuccess': {
        backgroundColor: palette.primary.light,
        color: palette.primary.dark,
      },
      '&.MuiAlert-outlined.MuiAlert-colorError': {
        border: `1px solid ${palette.error.main}`,
        color: palette.error.main,
      },
      '&.MuiAlert-outlined.MuiAlert-colorSuccess': {
        border: `1px solid ${palette.primary.main}`,
        color: palette.primary.main,
      },
    },
  },
  variants: [
    {
      props: { variant: 'trailerWizard' },
      style: {
        boxShadow: 'none',
      },
    },
    {
      props: { severity: 'warning', variant: 'trailerWizard' },
      style: {
        border: `1px solid ${palette.yellow.main}`,
        color: palette.warning.dark,
      },
    },
    {
      props: { severity: 'info', variant: 'trailerWizard' },
      style: {
        ...typography.body2,
        [`& .${alertClasses.icon}`]: {
          color: palette.graphic.main,
        },
        backgroundColor: palette.graphic.light,
        color: palette.text.secondary,
      },
    },
  ],
};

export default MuiAlert;
